/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    $(document).ready(function () {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.

    var $window = $(window),
        $document = $(document),
        $body = $('body');

    // In view scroll
    function elementInView() {
        $(".iv-wp").each(function () {
            new Waypoint.Inview({
                element: this,
                enter: function (direction) {
                    $(this.element).addClass('el-iv');
                }
            });
        });
    }


    $window.load(function () {
        elementInView();
    });

    var Sage = {
        // All pages
        'common': {
            init: function () {

                window.setTimeout(function () {
                    $('.banner-image').addClass('el-scale-up');
                }, 4000);

                $(".services-card").hover(
                    function () {
                        $(this).addClass('hover');
                    },
                    function () {
                        $(this).removeClass('hover');
                    }
                );

                var controller = new ScrollMagic.Controller({horizontal: false});
                var bannerHeight = $('#banner').height();
                var servicesHeight = $('.services-banner').height();
                var durationHeight = $('#logo-navigation').height();
                var benefitsHeight = $('#benefits-container').height();
                var teamHeight = $('.team-container').height();

                var websiteIntro = new TimelineMax()
                    .add([
                        TweenMax.fromTo(".banner-initial", 1, {opacity: 1}, {
                            opacity: 0,
                            ease: Quint.easeOut,
                            delay: 1
                        }),
                        TweenMax.fromTo(".banner-initial", 1, {left: 0}, {
                            left: "-100%",
                            ease: Quint.easeOut,
                            delay: 2
                        }),
                    ]);

                var banner_tween = new TimelineMax()
                    .add([
                        TweenMax.fromTo(".center-banner__para-text", 1, {y: 0}, {
                            y: -200,
                            ease: Linear.easeNone
                        }),
                        TweenMax.fromTo(".banner-image-wrap", 1, {y: 0}, {
                            y: 200,
                            ease: Linear.easeNone
                        }),
                    ]);

                var services_tween = new TimelineMax()
                    .add([
                        TweenMax.fromTo(".services-banner-initial", 1, {opacity: 0}, {
                            opacity: 1,
                            ease: Linear.easeNone
                        }),
                        TweenMax.fromTo(".services-image", 1, {scale: 1.15}, {
                            scale: 1,
                            ease: Linear.easeNone
                        })
                    ]);

                var about_tween = new TimelineMax()
                    .add([
                        TweenMax.fromTo(".about-banner", 1, {y: -40}, {
                            y: 100,
                            ease: Linear.easeNone
                        })
                    ]);

                var team_tween = new TimelineMax();

                var intro_scene = new ScrollMagic.Scene({
                    triggerElement: "body",
                    duration: 0,
                    scrollOffset: -1
                })
                    .setTween(websiteIntro)
                    .triggerHook(0)
                    //.addIndicators()
                    .addTo(controller);

                var banner_scene = new ScrollMagic.Scene({
                    triggerElement: "body",
                    duration: bannerHeight
                })
                    .setTween(banner_tween)
                    .triggerHook(0)
                    //.addIndicators()
                    .addTo(controller);

                var about_scene = new ScrollMagic.Scene({
                    triggerElement: ".about-container",
                    duration: bannerHeight
                })
                    .setTween(about_tween)
                    .offset(-300)
                    .triggerHook(0)
                    //.addIndicators()
                    .addTo(controller);

                var services_scene = new ScrollMagic.Scene({
                    triggerElement: ".services-single",
                    duration: servicesHeight
                })
                    .setTween(services_tween)
                    .triggerHook(0)
                    //.addIndicators()
                    .addTo(controller);

                var team_container = new ScrollMagic.Scene({
                    triggerElement: ".services-container",
                    duration: teamHeight
                })
                    .setTween(team_tween)
                    .triggerHook(0)
                    //.addIndicators()
                    .addTo(controller);

                // NAV Hover
                setTimeout(function () {
                    //$('.banner-image').addClass("remove-transition");
                    //$('.banner-initial').addClass("translate-left");
                }, 2600);

                var body = document.body,
                    html = document.documentElement;

                var height = Math.max(body.scrollHeight, body.offsetHeight,
                    html.clientHeight, html.scrollHeight, html.offsetHeight);
                //console.log(height);

                var slideValue = $('body').attr("data-slide-value"); // will return the string "123"
                var popupDelay = $('body').attr("data-timer-delay"); // will return the string "123"
                var popupDelayBoost = popupDelay * 1000;

                if (popupDelay) {
                    setTimeout(function () {
                        if ($('.popup-secondary-cta').hasClass('active')) {
                            $('.popup-secondary-cta').removeClass('active');
                            $('.popup-secondary-cta').removeClass('box-shadow');
                            setTimeout(function () {
                                $('.popup-secondary-cta').removeClass('hidden');
                                $('.popup-secondary-cta').addClass('hidden-background');
                            }, 1900);
                        } else {
                            $('.popup-secondary-cta').removeClass('hidden-background');
                            $(".popup-secondary-cta").addClass('active');
                            $('.popup-secondary-cta').addClass('box-shadow');
                        }
                    }, popupDelayBoost);
                }

                var individualPixel = height / 100;
                var finalPixel = individualPixel * slideValue;

                $("#slide-waypoint").css({
                    top: finalPixel,
                    left: 200,
                    position: 'absolute'
                });

                // Waypoint code for social icons side menu on blog inner
                var waypointsSocial = $('#slide-waypoint').waypoint({
                    handler: function (direction) {

                        if (direction === "down") {
                            if ($('.slide-secondary-cta').hasClass('active')) {
                                $('.slide-secondary-cta').removeClass('active');
                                $('.slide-secondary-cta').removeClass('box-shadow');
                                setTimeout(function () {
                                    $('.slide-secondary-cta').removeClass('hidden');
                                    $('.slide-secondary-cta').addClass('hidden-background');
                                }, 1900);
                            } else {
                                $('.slide-secondary-cta').removeClass('hidden-background');
                                $(".slide-secondary-cta").addClass('active');
                                $('.slide-secondary-cta').addClass('box-shadow');
                            }
                            this.destroy();
                        } else {

                        }

                    }
                });

                $(window).stellar({
                    horizontalScrolling: false
                });

                $('.utility-secondary').hover(
                    function () {
                        console.log("hover");
                        $('#utility-dropdown').addClass('active');
                    }, function () {
                        console.log("none-hover");
                        $('#utility-dropdown').removeClass('active');
                    }
                );

                var _ouibounce = ouibounce(document.getElementById('exit-cta'), {
                    aggressive: true,
                    timer: 0,
                    callback: function () {
                        if ($('.exit-cta').hasClass('active')) {
                            $('.exit-cta').removeClass('active');
                            $('.exit-cta').removeClass('box-shadow');
                            setTimeout(function () {
                                $('.exit-cta').removeClass('hidden');
                                $('.exit-cta').addClass('hidden-background');
                            }, 1900);
                        } else {
                            $('.exit-cta').removeClass('hidden-background');
                            $(".exit-cta").addClass('active');
                            $('.exit-cta').addClass('box-shadow');
                        }
                    }
                });

                // Logo Height

                var heightLogo = $('#logo-header').height();
                //$('#navigation-background').css({ 'height': heightLogo + "px" });

                // Quarter Height

                var fullHeight = $(window).height();
                var fulHeightAdjust = fullHeight;
                var quarterHeight = fullHeight * 0.75;
                if ($(window).width() < 768) {
                    $('.quarter-height').css({'height': fulHeightAdjust + "px"});
                } else {
                    $('.quarter-height').css({'height': quarterHeight + "px"});
                }
                //$('.full-height-header').css({ 'height': fulHeightAdjust + "px" });
                // $('.banner-image').css({'height': fullHeight + "px"});

                var rangeSlider = function () {
                    var slider = $('.range-slider'),
                        range = $('.range-slider__range'),
                        value = $('.range-slider__value');

                    slider.each(function () {

                        value.each(function () {
                            var value = $(this).prev().attr('value');
                            $(this).html(value);
                        });

                        range.on('input', function () {
                            $(this).next(value).html(this.value);
                        });
                    });
                };

                rangeSlider();

                // Video Popup

                $(".video").click(function () {
                    var theModal = $(this).data("target");
                    videoSRC = $(this).attr("data-video");
                    // console.log(videoSRC);
                    videoSRCauto = videoSRC + "?modestbranding=1&rel=0&controls=0&showinfo=0&html5=1&autoplay=1";
                    $('.popout').addClass("show");
                    $('.popout' + ' iframe').attr('src', videoSRCauto);
                    $('.popout' + ' a.btn-close').click(function () {
                        $('.popout').removeClass("show");
                    });
                });


                $('#bio_ep #bio_ep_close').click(function () {
                    $('#bio_ep .modal-content').removeClass('open');
                    $('#bio_ep .modal-content').addClass('out');
                });

                $('.modal--fix__timed .close').click(function () {
                    $('.modal--fix__timed .modal-content').removeClass('open');
                    $('.modal--fix__timed .modal-content').addClass('out');
                });

                $('.open-primary-modal').click(function () {
                    modalRef = $(this).attr("data-new-target");
                    console.log(modalRef);
                    $(modalRef).modal('show')
                    $('.modal .modal-content').removeClass('out');
                    // $('.modal .modal-content').addClass('open');
                });

                // functions
                function timedModal(dur_show, dur_hide) {
                    var modal = $('.modal--fix__timed'),
                        closeModal = modal.find('.close__icon');

                    //duration for ribbon
                    if (modal.data("duration") == '1sec') {
                        int1 = 1000;
                    } else if (modal.data("duration") == '3sec') {
                        int1 = 3000;
                    } else if (modal.data("duration") == '5sec') {
                        int1 = 5000;
                    } else if (modal.data("duration") == '10sec') {
                        int1 = 10000;
                    } else {
                        int1 = 0;
                    }
                    var timerId = setInterval(function () {

                        modal.slideDown(dur_show);

                    }, int1);

                    //close ribbon
                    closeModal.on('click', function () {

                        modal.slideUp(dur_hide);

                        clearInterval(timerId);

                    });

                }

                function setCookiesTimed() {
                    var container = $('#timed_popup');

                    if (!$.cookie('timed')) {

                        timedModal(0, 400);

                    }

                    if (container.data("cookiesTime") == '1day') {
                        $.cookie('timed', true, {
                            expires: 1,
                            path: '/'
                        });
                    } else if (container.data("cookiesTime") == '3day') {
                        $.cookie('timed', true, {
                            expires: 3,
                            path: '/'
                        });
                    } else if (container.data("cookiesTime") == '7day') {
                        $.cookie('timed', true, {
                            expires: 7,
                            path: '/'
                        });
                    } else {
                        $.cookie('timed', null);
                    }

                }

                function slideRibbon(dur_show, dur_hide) {
                    var modal = $('#ribbon'),
                        closeModal = modal.find('.ribbon__close');

                    //duration for ribbon
                    if (modal.data("duration") == '1sec') {
                        int1 = 1000;
                    } else if (modal.data("duration") == '3sec') {
                        int1 = 3000;
                    } else if (modal.data("duration") == '5sec') {
                        int1 = 5000;
                    } else if (modal.data("duration") == '10sec') {
                        int1 = 10000;
                    } else {
                        int1 = 0;
                    }

                    var timerId = setInterval(function () {

                        modal.slideDown(dur_show);

                    }, int1);

                    //close ribbon
                    closeModal.on('click', function () {

                        modal.slideUp(dur_hide);

                        clearInterval(timerId);

                    });

                }

                function setCookiesRibbon() {
                    var modal = $('#ribbon');
                    if (!$.cookie('ribbon')) {
                        slideRibbon(500, 300);
                    }
                    if (modal.data("cookiesTime") == '1day') {
                        $.cookie('ribbon', true, {
                            expires: 1,
                            path: '/'
                        });
                    } else if (modal.data("cookiesTime") == '3day') {
                        $.cookie('ribbon', true, {
                            expires: 3,
                            path: '/'
                        });
                    } else if (modal.data("cookiesTime") == '7day') {
                        $.cookie('ribbon', true, {
                            expires: 5,
                            path: '/'
                        });
                    } else if (modal.data("cookiesTime") == 'no-cookie') {
                        $.cookie('ribbon', null);
                    }
                }

                function slideModal(int1, dur_show, dur_hide, close) {
                    // console.log("modal-slider");
                    // var modal = $('#slide_in .modal-dialog'),
                    //     closeModal = $('.close--fix');

                    //interval for slidein modal
                    // var timerId = setInterval(function () {
                    //     modal.animate({
                    //         height: 'show'
                    //     }, {
                    //         duration: dur_show,
                    //         specialEasing: {
                    //             height: 'swing'
                    //         }
                    //     });
                    // }, int1);

                    //close slidein modal
                    // closeModal.on('click', function () {
                    //
                    //     modal.animate({
                    //         height: 'hide'
                    //     }, {
                    //         duration: dur_hide,
                    //         specialEasing: {
                    //             height: 'swing'
                    //         }
                    //     });
                    //
                    //     clearTimeout(timerId);
                    //
                    // });
                }
                function slideInScrollShow() {
                    var scrollHeight = Math.max(
                        document.body.scrollHeight, document.documentElement.scrollHeight,
                        document.body.offsetHeight, document.documentElement.offsetHeight,
                        document.body.clientHeight, document.documentElement.clientHeight
                    );
                    var scroll_25 = scrollHeight * 25 / 100 - ($(window).height()),
                        scroll_50 = scrollHeight * 50 / 100 - ($(window).height()),
                        scroll_75 = scrollHeight * 75 / 100 - ($(window).height()),
                        scroll_100 = scrollHeight - ($(window).height());

                    var container = $('#slide_in .modal-dialog');


                    $(document).scroll(function () {
                        var scrolling = $(window).scrollTop();

                        if (scrolling > scroll_25 && container.data("duration") == 25) {
                            slideModal(0, 700, 300);
                        } else if (scrolling > scroll_50 && container.data("duration") == 50) {
                            slideModal(0, 700, 300);
                        } else if (scrolling > scroll_75 && container.data("duration") == 75) {
                            slideModal(0, 700, 300);
                        } else if (scrolling >= scroll_100 && container.data("duration") == 100) {
                            slideModal(0, 700, 300);
                        }

                    });

                }

                function setCookiesSlidein() {

                    var container = $('#slide_in');
                    if (!$.cookie('slidein')) {
                        console.log('hit the part 1');
                        slideInScrollShow();
                    }

                    if (container.data("cookiesTime") == '1day') {
                        console.log('hit the part 2');
                        $.cookie('slidein', true, {
                            expires: 1,
                            path: '/'
                        });
                    } else if (container.data("cookiesTime") == '3day') {
                        console.log('hit the part 3');
                        $.cookie('slidein', true, {
                            expires: 3,
                            path: '/'
                        });
                    } else if (container.data("cookiesTime") == '7day') {
                        console.log('hit the part 4');
                        $.cookie('slidein', true, {
                            expires: 7,
                            path: '/'
                        });
                    } else {
                        console.log('hit the part 5');
                        slideInScrollShow();
                        $.cookie('slidein', null);
                    }

                }

                setCookiesTimed();
                setCookiesRibbon();
                setCookiesSlidein();

                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
                var banner_strapline = new Waypoint({
                    element: $('.banner-strapline')[0],
                    handler: function (direction) {
                        setTimeout(function () {
                            $('.services-container').addClass("clear-animation-speed").delay(3000);
                        }, 3000);
                    },
                    offset: 50
                })

                // var services_text = new Waypoint({
                //   element: $('.services-text')[0],
                //   handler: function(direction) {
                //       setTimeout(function(){
                //         $('.single-team-container').addClass("clear-animation-speed").delay(3000);
                //       }, 3000);
                //   },
                //   offset: -40
                // })
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    // Waypoint code for social icons side menu on blog inner
    var waypointsSocial = $('.article-content-container').waypoint({
        handler: function (direction) {

            if (direction === "down") {
                $('.articles-social-icons-side').css('position', 'fixed');
            } else {
                $('.articles-social-icons-side').css('position', 'absolute');
            }

        }
    });

    // var waypointsSocialBottom = $('.article-social-icons-bottom').waypoint({
    //   handler: function(direction) {
    //
    //     if(direction === "down"){
    //       $('.articles-social-icons-side').css('position', 'absolute');
    //       $('.articles-social-icons-side').css('top', 'none');
    //     } else {
    //       $('.articles-social-icons-side').css('position', 'fixed');
    //     }
    //
    //   }
    // });


    /** //////////////////////////////////////////////
     *                 Start Blog-page
     *   /////////////////////////////////////////////
     */


    //region blog-page

    // remove sidebar-primary class from the body on blog page and single page
    $('.page-template-archive,.single-post,.page-template-template-contact-us,.page-template-template-teams, .archive').removeClass('sidebar-primary');

    // change placeholder for the search input on blog page
    $(".blog-search-form .search-field").attr('placeholder', 'SEARCH...');

    var ajaxscript = $ss_home_url + 'wp-admin/admin-ajax.php';
    /******************************************
     * Get Posts With Ajax while Searching
     * ****************************************/
    var throttled = false;
    var delay = 1500;
    $('.blog-search-form .search-field').keyup(function () {
        var keyword_text = $(this).val();
        if (!throttled) {
            // actual callback action
            $.ajax({
                url: ajaxscript,
                type: 'POST',
                data: {
                    keyword_text: keyword_text,
                    action: 'blog_page_get_posts_by_search'
                },
                success: function (data) {
                    $('.data-ajax-posts').animate({
                        top: 200,
                        opacity: 0
                    }, 400, function () {
                        $(this).html(data);
                    });
                    $('.data-ajax-posts').animate({
                        top: 0,
                        opacity: 1
                    }, 200);
                }
            });
            // we're throttled!
            throttled = true;
            // set a timeout to un-throttle
            setTimeout(function () {
                throttled = false;
            }, delay);
        }

    });

    /******************************************
     * Get Posts With Ajax Per Category
     * ****************************************/
    $('.categories-list li.cat-link a').on('click', function () {
        var cat_id = $(this).data('cat-id');
        $.ajax({
            url: ajaxscript,
            type: 'POST',
            data: {
                cat_id: cat_id,
                action: 'blog_page_get_cat_posts'
            },
            success: function (data) {
                $('.data-ajax-posts').animate({
                    top: 200,
                    opacity: 0
                }, 400, function () {
                    $(this).html(data);
                });
                $('.data-ajax-posts').animate({
                    top: 0,
                    opacity: 1
                }, 200);
            }
        })
    });

    /***********************************************
     * Add Slick Slider To categories on Blog Page
     * *********************************************/
    $('.categories-list').slick({
        dots: false,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }

        ]
    });

    /***********************************************
     * make the top slider on the blog page
     * *********************************************/
    var activeArticleIndex = 0;
    var postInterval = parseFloat($('.blog-page-top-posts-slider').attr('data-post-interval')); // to get the duration from HTML
    var $articles = $('.blog-page-top-posts-slider .post,.blog-page-top-posts-slider .switch');
    var intervalID;

    /**
     * this function takes an element and divids it into many spans according to the limit of the characters number
     * @param $element the element that we need to divide its text
     * @param charLimit the max number of characters in each span
     * @return the divided element into many spans
     */
    function divideText($element, charLimit) {
        var text = $.trim($element.html());
        var $result = $('<div></div>');
        var tempText = '';
        var hasSpace = true;
        var nextWhiteSpace = 0;
        var lastWhiteSpace = 0;
        while (text.length > 0) {
            tempText = '';
            hasSpace = true;
            nextWhiteSpace = 0;
            lastWhiteSpace = 0;
            while (hasSpace) {
                nextWhiteSpace = text.indexOf(' ', lastWhiteSpace);
                if (nextWhiteSpace == -1) {
                    hasSpace = false;
                    if (lastWhiteSpace == 0) {
                        text.length > 0 ? $result.append($('<span></span>').addClass('outer').append($('<span></span>').append(text))) : '';
                        text = '';
                    } else {
                        if (text.length <= charLimit) {
                            $result.append($('<span></span>').addClass('outer').append($('<span></span>').append(text)));
                            text = '';
                        }
                        else {
                            tempText = text.slice(0, lastWhiteSpace - 1);
                            text = text.slice(lastWhiteSpace);
                            $result.append($('<span></span>').addClass('outer').append($('<span></span>').append(tempText)));
                            tempText = '';
                        }
                    }

                } else if (nextWhiteSpace <= charLimit) {
                    lastWhiteSpace = nextWhiteSpace + 1;
                } else {
                    hasSpace = false;
                    tempText = text.slice(0, lastWhiteSpace - 1);
                    text = text.slice(lastWhiteSpace);
                    $result.append($('<span></span>').addClass('outer').append($('<span></span>').append(tempText)));
                    tempText = '';
                }
            }
        }
        return $result.html();
    }

    $(document).ready(function () {
        var $element = $('.blog-page-top-posts-slider .post .title');
        $element.each(function () {
            $(this).html(divideText($(this), 25));
        });
    });


    /**
     * function to be attached to the timeInterval callback
     * toggle 'active' class to make header slider works properly
     * and updates activeArticleIndex
     */
    function articleTimeInterval() {
        $articles.each(function (i) {
            var $this = $(this);
            var $progress = $this.children('.progress');
            if (i - 3 == activeArticleIndex || i == activeArticleIndex) {
                $this.addClass('active');
                $progress.css('transition-duration', postInterval + 's');
            } else {
                $this.removeClass('active');
                $progress.css('transition-duration', '1s');
            }
        });
        activeArticleIndex = (activeArticleIndex + 1) % 3;
    }

    articleTimeInterval();
    intervalID = window.setInterval(articleTimeInterval, postInterval * 1000);


    // resets the interval timer with each click
    $('.switch').click(function () {
        activeArticleIndex = parseInt($(this).attr('data-index'));
        window.clearInterval(intervalID);
        articleTimeInterval();
        intervalID = window.setInterval(articleTimeInterval, postInterval * 1000);
    });

    //position the switches when resize the window

    // var $switches = $('.switches');
    // var $topSliderContainer = $('.blog-page-top-posts-slider .post .container');
    // var windowWidthRange = [576, 991];
    //
    // function swithchesPosition($element, $target, windowSize, windowWidthRange) {
    //     if (windowSize >= windowWidthRange[0] && windowSize <= windowWidthRange[1]) {
    //         $element.css('left', parseFloat($target.css('margin-left')) + 30 + 'px')
    //     } else if (windowSize < windowWidthRange[0]) {
    //         $element.css('right', 'unset');
    //         $element.css('left', '50%');
    //     } else {
    //         $element.css('left', 'unset');
    //         $element.css('right', parseFloat($target.css('margin-right')) + 30 + 'px');
    //     }
    // }
    //
    // swithchesPosition($switches, $topSliderContainer, $(window).width(), windowWidthRange);
    //
    // $(window).resize(function () {
    //     swithchesPosition($switches, $topSliderContainer, $(this).width(), windowWidthRange);
    //
    // });


    //endregion


    /** //////////////////////////////////////////////
     *              start single-page
     *  /////////////////////////////////////////////
     */


        //region single-page

    var waypointsSinglePageFooter = $('#footer').waypoint({
            handler: function (direction) {
                $('.article-middle-container').toggleClass('not-in-view');
                $('.top-section-scroll').toggleClass('not-in-view');
                $('.article-bottom-container').toggleClass('in-view');
            },
            offset: '99%'
        });
    //endregion


    /** //////////////////////////////////////////////
     *              start contact-us-page
     *  /////////////////////////////////////////////
     */

    //region contact-us
    $(window).ready(function () {
        $("[id^='map']").each(function () {
            $(this).height($('.contact-info-section').outerHeight())
        });
    });
    $(window).resize(function () {
        $("[id^='map']").each(function () {
            $(this).height($('.contact-info-section').outerHeight())
        });
    });


    //endregion

    //region  start team-module-slider-page
    //region team-module-slider
    $('.team-members-module-container').parent().css('overflow', 'hidden');
    // initialize the slider components
    //region  start team-module-slider-page
    //region team-module-slider

    // initialize the slider components
    var $members = $('.team-members').children(),
        $rightThumbnailGroup = $('.right-thumbnail-group'),
        $leftThumbnailGroup = $('.left-thumbnail-group'),
        $activeTextGroup = $('.active-group .active-text-group').css('z-index', 0),
        $activeImgGroup = $('.active-group .active-img-group').css('z-index', 0),
        $memberLinks = $('.member-links'),
        $pop_up_team_image = $('.pop_up_team_image'),
        $pop_up_team_text = $('.pop_up_team_text'),
        len = $members.length,
        currentActive = 0,
        animationSpeed = 1,
        scaleValue = 1.5,
        clipExpanded,
        clipExpanded2,
        clipCollapsedRight,
        clipCollapsedLeft,
        clipMidCollapsedRight,
        clipMidCollapsedLeft,
        clipMidExpandedRight,
        clipMidExpandedLeft
    ;

    function setClipPath(points) {
        return "polygon(" +
            points[0] + "% " + points[1] + "%, " +
            points[2] + "% " + points[3] + "%, " +
            points[4] + "% " + points[5] + "%, " +
            points[6] + "% " + points[7] + "%)";
    }
    
    $members.each(function (index) {
        var $this = $(this),
            img = $this.data('img'),
            nameFull = $this.data('name-full'),
            nameShort = $this.data('name-short'),
            job = $this.data('job'),
            description = $this.data('description'),
            $img = $('<img>').attr('src', img),
            $memberLink = $('<div class="col-2 member-link"></div>')
                .append($('<h4 class="name"></h4>').html(nameShort))
                .append($('<h6 class="job mt-1"></h6>').html(job)),

            $textContainer = $('<div class="text-container"></div>').css({'z-index': (len - 1 - index) % len})
                .append($('<h4 class="name"></h4>').html(nameFull))
                .append($('<h6 class="job mt-2"></h6>').html(job))
                .append($('<p class="description my-4"></p>').html(description))
                .append($('<a class="right-arrow-black team-arrow mt-5">READ MORE</a>'));

        $('.team-arrow').addClass('text');

        if (index == 0) {
            $memberLink.addClass('active');
        }
        var $activeImg = $img.clone().css({'z-index': (len - 1 - index) % len});
        $rightThumbnailGroup.append($img.clone().css({'z-index': (len - index) % len}));
        $leftThumbnailGroup.append($img.clone().css({'z-index': index}));
        $activeImgGroup.append($activeImg);
        $activeTextGroup.append($textContainer);
        $memberLinks.append($memberLink);
    });
    // $(".team-arrow").click(function () {
    //     TweenMax.set($pop_up_team_image, {scale: 1.11});
    //     $('.pop-up-team-member').css('transform', 'translateX(0)');
    //     var pop_up_number = ((currentActive % len) + len) % len;
    //     var pop_up_data = $members.eq(pop_up_number);
    //     $pop_up_team_image.attr('src', pop_up_data.data('img'));
    //     $pop_up_team_text.children('.member-name').html(pop_up_data.data('nameFull'));
    //     $pop_up_team_text.children('.member-job').html(pop_up_data.data('job'));
    //     $pop_up_team_text.children('.member-desc').html(pop_up_data.data('description'));
    //     TweenMax.to($pop_up_team_image, 15, {scale: 1, ease: Linear.easeNone});
    // });
    
  
   
    $(".team-arrow").click(function () {
        alert('das');
        var single_team_image = $(this).parent().parent().find('.single-team-image');
        var single_team_name = $(this).parent().find('.single-team-name');
        var single_team_job = $(this).parent().find('.single-team-job');
        var single_team_description = $(this).parent().find('.single-team-description');

        
        $('.pop-up-team-member').css('transform', 'translateX(0)');
        $pop_up_team_image.attr('src', single_team_image.attr('src'));
        $pop_up_team_text.children('.member-name').html(single_team_name.text());
        $pop_up_team_text.children('.member-job').html(single_team_job.text());
        $pop_up_team_text.children('.member-desc').html(single_team_description.data('full-description'));
        
        var tl = new TimelineMax();
        tl
        .set($pop_up_team_image, {scale: 1.11})
        .to($pop_up_team_image, 15, {scale: 1, ease: Linear.easeNone});
    });
   

    $('.pop-up-team-member, .close-pop-up').on('click', function () {
        $(this).css('transform', 'translateX(100%)');
        TweenMax.set($pop_up_team_image, {scale: 1.11});
    });

    $(document).keydown(function(e) {
        if (e.keyCode == 27) {
            $('.pop-up-team-member').css('transform', 'translateX(100%)');
            TweenMax.set($pop_up_team_image, {scale: 1.11});
        }
    });

    TweenMax.set([$activeImgGroup.children(), $leftThumbnailGroup.children(), $rightThumbnailGroup.children()], {
        scale: 1,
        x: '-50%',
        y: '-50%',
        top: '50%',
        left: '50%'
    });
    TweenMax.set($activeImgGroup.children().eq(0), {scale: scaleValue});
    TweenMax.set($activeTextGroup.children(':not(:first-of-type)'), {y: "-100%", autoAlpha: 0});
 

    // initializing GSAP
    function tweenTo(currentActive, target, time) {
        var tl = new TimelineMax();

        $memberLinks.children().each(function () {
            $(this).removeClass('active');
        });

        var $rightThumbnail;
        var $nextRightThumbnail;
        var $prevRightThumbnail;
        var $leftThumbnail;
        var $nextLeftThumbnail;
        var $prevLeftThumbnail;
        var $activeThumbnail;
        var $nextActiveThumbnail;
        var $prevActiveThumbnail;
        var $activeText;
        var $nextActiveText;
        var $notNextActiveText;
        var cActive;
        var nActive;
        var pActive;

        clipExpanded = [0, 0, 100, 0, 100, 100, 0, 100];
        clipExpanded2 = [0, 0, 100, 0, 100, 100, 0, 100];
        clipCollapsedRight = [100, 0, 100, 0, 100, 100, 100, 100];
        clipCollapsedLeft = [0, 0, 0, 0, 0, 100, 0, 100];
        clipMidCollapsedRight = [25, 0, 100, 0, 100, 100, 75, 100];
        clipMidCollapsedLeft = [0, 0, 75, 0, 25, 100, 0, 100];
        clipMidExpandedRight = [75, 0, 100, 0, 100, 100, 25, 100];
        clipMidExpandedLeft = [0, 0, 25, 0, 75, 100, 0, 100];

        if (target > currentActive) { //next

            cActive = ((currentActive % len) + len) % len;
            nActive = (((currentActive + 1) % len) + len) % len;
            pActive = (((currentActive - 1) % len) + len) % len;


            $memberLinks.children().eq(nActive).addClass('active');
            $rightThumbnail = $rightThumbnailGroup.children().eq(cActive);
            $nextRightThumbnail = $rightThumbnailGroup.children().eq(nActive);
            $nextLeftThumbnail = $leftThumbnailGroup.children().eq(nActive);
            $prevLeftThumbnail = $leftThumbnailGroup.children().eq(pActive);
            $leftThumbnail = $leftThumbnailGroup.children().eq(cActive);
            $activeThumbnail = $activeImgGroup.children().eq(cActive);
            $nextActiveThumbnail = $activeImgGroup.children().eq(nActive);
            $prevActiveThumbnail = $activeImgGroup.children().eq(pActive);
            $activeText = $activeTextGroup.children().eq(cActive);
            $nextActiveText = $activeTextGroup.children().eq(nActive);
            $notNextActiveText = $activeTextGroup.children().not(':eq(' + nActive + ')');


            clipMidExpandedRight.onUpdate = function () {
                // console.log('going to clipMidExpandedRight');
                TweenMax.set([$nextActiveThumbnail, $leftThumbnail], {css: {'clip-path': setClipPath(clipCollapsedRight)}});
            };
            clipMidExpandedRight.ease = Power2.easeIn;

            clipExpanded.onUpdate = function () {
                // console.log('going to clipExpanded');
                TweenMax.set([$nextActiveThumbnail, $leftThumbnail], {css: {'clip-path': setClipPath(clipMidExpandedRight)}});
            };
            clipExpanded.ease = Power2.easeOut;

            clipMidCollapsedLeft.onUpdate = function () {
                // console.log('going to clipMidCollapsedLeft');
                TweenMax.set($nextRightThumbnail, {css: {'clip-path': setClipPath(clipExpanded2)}});
            };
            clipMidCollapsedLeft.ease = Power2.easeIn;

            clipCollapsedLeft.onUpdate = function () {
                // console.log('going to clipCollapsedLeft');
                TweenMax.set($nextRightThumbnail, {css: {'clip-path': setClipPath(clipMidCollapsedLeft)}});
            };
            clipCollapsedLeft.ease = Power2.easeOut;


            tl
                .addLabel('start')
                .set([$nextActiveThumbnail, $leftThumbnail], {css: {'clip-path': setClipPath(clipCollapsedRight)}}, 'start')
                .set([$nextActiveThumbnail, $leftThumbnail], {zIndex: "+=" + len})
                .set($nextActiveThumbnail, {scale: 1})
                .to(clipCollapsedRight, time / 2, clipMidExpandedRight)
                .to(clipMidExpandedRight, time / 2, clipExpanded)
                .to($nextActiveThumbnail, time * 2 / 3, {scale: scaleValue}, 'start+=' + time / 3)
                .set($activeText, {zIndex: '-=' + len}, 'start')
                .to($activeText, time, {y: '100%', autoAlpha: 0}, 'start')
                .to($nextActiveText, time, {y: '0%', autoAlpha: 1}, 'start')
                .set($activeText, {y: '-100%'}, 'start+=' + time)
                .set([$activeThumbnail, $nextActiveThumbnail], {zIndex: "-=" + len})
                .set([$activeThumbnail, $leftThumbnail], {css: {'clip-path': setClipPath([0, 0, 100, 0, 100, 100, 0, 100])}})
                .set($nextRightThumbnail, {css: {'clip-path': setClipPath(clipExpanded)}}, 'start')
                .to(clipExpanded2, time / 2, clipMidCollapsedLeft, 'start')
                .to(clipMidCollapsedLeft, time / 2, clipCollapsedLeft, 'start+=' + time / 2)
                .set($nextRightThumbnail, {zIndex: "-=" + len}, 'start+=' + time)
                .set($nextRightThumbnail, {css: {'clip-path': setClipPath([0, 0, 100, 0, 100, 100, 0, 100])}}, 'start+=' + time)

        } else if (target < currentActive) { //prev

            cActive = ((currentActive % len) + len) % len;
            nActive = (((currentActive - 1) % len) + len) % len;
            $memberLinks.children().eq(nActive).addClass('active');
            $rightThumbnail = $rightThumbnailGroup.children().eq(cActive);
            $nextRightThumbnail = $rightThumbnailGroup.children().eq(nActive);
            $leftThumbnail = $leftThumbnailGroup.children().eq(cActive);
            $nextLeftThumbnail = $leftThumbnailGroup.children().eq(nActive);
            $activeThumbnail = $activeImgGroup.children().eq(cActive);
            $nextActiveThumbnail = $activeImgGroup.children().eq(nActive);
            $activeText = $activeTextGroup.children().eq(cActive);
            $nextActiveText = $activeTextGroup.children().eq(nActive);


            clipMidExpandedLeft.onUpdate = function () {
                // console.log('going to clipMidExpandedLeft');
                TweenMax.set([$nextActiveThumbnail, $rightThumbnail], {css: {'clip-path': setClipPath(clipCollapsedLeft)}});
            };
            clipMidExpandedLeft.ease = Power2.easeIn;

            clipExpanded.onUpdate = function () {
                // console.log('going to clipExpanded');
                TweenMax.set([$nextActiveThumbnail, $rightThumbnail], {css: {'clip-path': setClipPath(clipMidExpandedLeft)}});
            };
            clipExpanded.ease = Power2.easeOut;

            clipMidCollapsedRight.onUpdate = function () {
                // console.log('going to clipMidCollapsedRight');
                TweenMax.set($nextLeftThumbnail, {css: {'clip-path': setClipPath(clipExpanded2)}});
            };
            clipMidCollapsedRight.ease = Power2.easeIn;

            clipCollapsedRight.onUpdate = function () {
                // console.log('going to clipCollapsedRight');
                TweenMax.set($nextLeftThumbnail, {css: {'clip-path': setClipPath(clipMidCollapsedRight)}});
            };
            clipCollapsedLeft.ease = Power2.easeOut;


            tl
                .addLabel('start')
                .set([$nextActiveThumbnail, $rightThumbnail], {css: {'clip-path': setClipPath(clipCollapsedLeft)}}, 'start')
                .set([$nextActiveThumbnail, $rightThumbnail], {zIndex: "+=" + len})
                .set($nextActiveThumbnail, {scale: 1})
                .to(clipCollapsedLeft, time / 2, clipMidExpandedLeft)
                .to(clipMidExpandedLeft, time / 2, clipExpanded)
                .to($nextActiveThumbnail, time * 2 / 3, {scale: scaleValue}, 'start+=' + time / 3)
                .set($nextActiveText, {y: '100%', zIndex: '+=' + len}, 'start')
                .to($nextActiveText, time, {y: '0%', autoAlpha: 1}, 'start')
                .to($activeText, time, {y: '-100%', autoAlpha: 0}, 'start')
                .set([$activeThumbnail, $rightThumbnail], {css: {'clip-path': setClipPath([0, 0, 100, 0, 100, 100, 0, 100])}})
                .set($nextLeftThumbnail, {css: {'clip-path': setClipPath(clipExpanded)}}, 'start')
                .to(clipExpanded2, time / 2, clipMidCollapsedRight, 'start')
                .to(clipMidCollapsedRight, time / 2, clipCollapsedRight, 'start+=' + time / 2)
                .set($nextLeftThumbnail, {zIndex: "-=" + len}, 'start+=' + time)
                .set($nextLeftThumbnail, {css: {'clip-path': setClipPath([0, 0, 100, 0, 100, 100, 0, 100])}}, 'start+=' + time)
        }
        return tl;
    }

    $rightThumbnailGroup.click(function () {
        tweenTo(currentActive, ++currentActive, animationSpeed);
    });
    $leftThumbnailGroup.click(function () {
        tweenTo(currentActive, --currentActive, animationSpeed);
    });

    $('.member-link').click(function () {
        var target = $(this).index('.member-link'),
            tweens = [];
        currentActive = ((currentActive % len) + len) % len;
        if (target > currentActive) {
            for (i = currentActive; i < target; i++) {
                tweens.push(tweenTo(currentActive, ++currentActive, animationSpeed));
            }
            tweens.reverse();

        } else if (target < currentActive) {
            for (i = currentActive; i > target; i--) {
                tweens.push(tweenTo(currentActive, --currentActive, animationSpeed));
            }
        }
        // console.log(tweens);
        var tl = new TimelineMax({tweens: tweens, align: "normal", paused: true});
        tl.set($activeImgGroup.children().eq(((currentActive % len) + len) % len), {zIndex: '-=100'});
        tl.set($activeImgGroup.children().eq(((currentActive % len) + len) % len), {zIndex: '+=100'}, 0);
        tl.set($activeTextGroup.children().not(':eq(' + ((currentActive % len) + len) % len + ')'), {y: '-100%'});
        tl.play()
        // tl.timeScale(tweens.length/2);
        // console.log(((currentActive % len) + len) % len);
    });
    //endregion

    //endregion  End team-module-slider-page


    //region Header Video Pop-up
    /*stop the video when closing the pop-up
    + auto play the video when opening the modal
    + add an overlay to make a good view for the modal*/
    $(".custom-bootstrap-modal-video-button").click(function () {
        var theModal = $(this).data("target"),
            videoSRC = $(this).data("video"),
            videoSRCauto = videoSRC + "?modestbranding=1&rel=0&showinfo=0&html5=1&autoplay=1";
        $(theModal + ' iframe').attr('src', videoSRCauto);
        $(theModal + ' iframe').css('opacity', '1');
        setTimeout(function () {
            $(theModal).addClass('noAfter');
        }, 800);
        $(theModal + ' button.close').click(function () {
            $(theModal + ' iframe').attr('src', videoSRC);
            $(theModal).removeClass('noAfter');
        });
        $(theModal).on('hidden.bs.modal', function (e) {
            $(theModal + ' iframe').attr('src', videoSRC);
            $(theModal).removeClass('noAfter');
        });
    });
    //endregion Header Video Pop-up






    $('.client-click').on('click',function () {
       $('.client-menu').slideToggle(200);
        if ( $(this).children('i').hasClass('angle-top')) {
            $(this).children('i').removeClass('angle-top');
        }else{
            $(this).children('i').addClass('angle-top');
        }

    });


    var modalShown = false;
    /*Slide In Modal Animation and Show*/
    $(document).scroll(function(e){

        // grab the scroll amount and the window height
        var scrollAmount = $(window).scrollTop();
        var documentHeight = $(document).height();

        // calculate the percentage the user has scrolled down the page
        var scrollPercent = (scrollAmount / documentHeight) * 100;

        var duration = $('#slide_in .modal-dialog').data('duration');
        // check if duration has value
        if(duration == ""){
            duration = 60; // add a default value
        }
        if(scrollPercent >= duration && !modalShown) {
            modalShown = true;
            slideInAnimation();
        }
    });
    function slideInAnimation() {
        var tl = new TimelineMax();
        tl
            .to('#slide_in .modal-dialog',.5, {autoAlpha:1,ease: Power2.easeInOut})
            .to('#slide_in .modal-body',.5, {y:0,ease: Power2.easeInOut})
            .to('#slide_in .modal-content',.5, {boxShadow:"-5px 7px 21px rgba(0, 0, 0, 0.16)",ease: Power2.easeInOut},"-=.3")
            .to('.slide-in-text',.3, {y:0,ease: Power2.easeInOut},"-=.4");
    }


    $('.close-modal-slide-in').on('click',function () {
            TweenMax.to('#slide_in .modal-content',.1, {boxShadow:"none",background:"transparent",ease: Power2.easeInOut});
            TweenMax.to('#slide_in .custom-ebook-slide-in',.3, {y:"-100%",ease: Power2.easeInOut});
            TweenMax.to('.slide-in-text',.4, {y:"-100%",ease: Power2.easeInOut});
            TweenMax.to('#slide_in .modal-body',.5, {y:"-100%",autoAlpha:0,ease: Power2.easeInOut});

        setTimeout(function(){
            $('#slide_in .modal-content').removeClass('modal-content');
            $('#slide_in .modal-body').html('');
            $('#slide_in').css('display','none');
            $('#slide_in .modal-content').css('display','none');
        }, 500);
        
       
    });
    
    });
})(jQuery); // Fully reference jQuery after this point.
